import { Coffee, Phone, Sunrise } from 'lucide-react';
import PageHero from '../components/PageHero';
import Seo from '../components/Seo';
import { CONTACT } from '../data/siteData';

export default function Nespresso() {
  return (
    <>
      <Seo title="Jonny’s Towing × Nespresso" description="Jonny's Towing elevates early-morning roadside service with complimentary Nespresso coffee on eligible flatbed calls." image="/images/rolls-royce-flatbed.webp" />
      <PageHero
        eyebrow="Jonny’s Towing × Nespresso"
        title="Powerful solutions. Premium roadside experiences."
        description="Because a difficult morning can still include one thoughtful detail. This signature Jonny’s experience turns an ordinary tow into something customers remember."
        image="/images/rolls-royce-flatbed.webp"
      >
        <a className="button button--primary" href={CONTACT.phoneHref}><Phone size={18} /> Call for roadside help</a>
      </PageHero>
      <section className="section container nespresso-grid">
        {[
          ['Drive it.', 'Professional towing and roadside solutions delivered with precision, communication and care.'],
          ['Brew it.', 'On eligible flatbed calls arriving between 5:00 AM and 9:00 AM, customers may be offered a freshly brewed Nespresso coffee at no cost.'],
          ['Taste it.', 'A rotating selection of popular blends, including specialty seasonal options when available.'],
          ['Blend it.', 'Reliable towing expertise and a small premium touch combine to make an inconvenient morning feel more manageable.'],
        ].map(([title, text], index) => (
          <article className="nespresso-card" key={title}>
            {index % 2 === 0 ? <Coffee /> : <Sunrise />}
            <span>0{index + 1}</span>
            <h2>{title}</h2>
            <p>{text}</p>
          </article>
        ))}
      </section>
      <section className="section section--dark">
        <div className="container centered-heading">
          <span className="eyebrow">One of the details that sets Jonny’s apart</span>
          <h2>Premium roadside service is not about pretending a breakdown is pleasant. It is about making the experience meaningfully better.</h2>
          <p>Availability depends on the truck, service type, time and current supplies. Nespresso is a trademark of its respective owner.</p>
        </div>
      </section>
    </>
  );
}
